import { QueryClient } from "@tanstack/react-query";

/**
 * **Der eine QueryClient der Seite.** Jede Ansicht lädt beim Öffnen frisch
 * (`staleTime: 0`, wie früher jeder Seitenwechsel neu baute) und zeigt dabei,
 * was sie schon hat. Kein Nachladen beim Fokuswechsel: Ein stilles Neuladen
 * beim Zurückkehren in den Tab risse offene Formulare um. Keine stille
 * Wiederholung: Ein Fehler soll sofort als Satz dastehen, nicht nach drei
 * Versuchen.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, refetchOnWindowFocus: false, staleTime: 0 },
      mutations: { retry: false },
    },
  });
}
